module.exports = __webpack_public_path__ + "img/twotit.02188c20.png";